import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import titleMixin from './mixins/title';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import VeeValidate from 'vee-validate';
import VEasyDialog from 'v-easy-dialog';
import myUpload from 'vue-image-crop-upload';
import 'vue-image-crop-upload/upload.css';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import moment from 'moment';

Vue.config.productionTip = false; 

Vue.mixin(titleMixin);

const EventBus = new Vue();
Vue.prototype.$eventBus = EventBus;

//moment.locale('zh-cn'); 
Vue.prototype.$moment = moment; 

Vue.component('Swiper', Swiper);
Vue.component('SwiperSlide', SwiperSlide);
Vue.use(VeeValidate);
Vue.use(VEasyDialog);
Vue.component('myUpload', myUpload);
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 13,
  newestOnTop: true,
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
});
import './assets/style/reset_css.css'
import './assets/style/all.css'
new Vue({
  router,
  store,
  moment,
  render: h => h(App)
}).$mount('#app');
